import { FeatureFlag, supportedFlags } from '@module/types';

export const CACHE_KEYS = {
  USER: '@fusion/auth/user',
  USER_PUBLIC: '@fusion/auth/user-public',
};

// Keeps track of the feature flags assigned to the current user
let userFlags: FeatureFlag[];

/**
 * Pass the user feature flags from their account to initialise
 * Any unrecognised flags will be dropped
 */
export function initialiseFlags(accountFlags: { [flagName in FeatureFlag]?: boolean }): void {
  userFlags = Object.entries(accountFlags)
    .filter(([flagName, value]) => supportedFlags.includes(flagName as FeatureFlag) && value === true)
    .map(([flagName]) => flagName as FeatureFlag);
}

/**
 * Returns true/false to indicate whether the feature flags have been initialised
 */
export function isInitialised(): boolean {
  return userFlags !== undefined;
}

/**
 * Pass a feature flag to see if it's enabled for the current user
 * NOTE: you must have called initialiseFlags() before using this
 */
export function featureEnabled(flag: FeatureFlag): boolean {
  if (!userFlags) {
    throw new Error("no user flags found, please ensure you've called initialise()");
  }

  return userFlags.includes(flag);
}
